import roles from "../models/roles";
import firebase from "firebase/app";
import "firebase/firestore";
import { getPermittedActionsForUserRole } from "../../authorization/api/authorizationApi";
import { setPermittedActions } from "../../authorization/models/permittedActions";
import { useEffect, useState } from "react";

export async function createUser(uid, name, email, photoUrl) {
  console.log(uid, name, email, photoUrl);
  const userObj = {
    name: name,
    email: email,
    photoUrl: photoUrl,
    role: roles.VIEWER.name,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  };

  var db = firebase.firestore();

  await db.collection("users").doc(uid).set(userObj);

  return await getUser(uid);
}

export async function getUser(uid) {
  var db = firebase.firestore();
  var doc = await db.collection("users").doc(uid).get();
  return doc.data();
}

export function useUser(uid) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!uid) return;
    async function fetchUser() {
      const userData = await getUser(uid);
      setUser(userData);
    }
    fetchUser();
  }, [uid]);

  return user;
}

export async function getUserDetails(firebaseUser, googleUid) {
  var userObj = await getUser(googleUid);
  if (!userObj) {
    userObj = await createUser(
      googleUid,
      firebaseUser.displayName,
      firebaseUser.email,
      firebaseUser.photoURL
    );
  }
  userObj.uid = googleUid;
  return userObj;
}

export async function setUserPermittedActions(role) {
  var permittedActionsByUser = await getPermittedActionsForUserRole(role);
  setPermittedActions(permittedActionsByUser.actions);
}

export async function getAllUsers() {
  var db = firebase.firestore();
  var snapshot = await db.collection("users").orderBy("name").get();
  return snapshot.docs.map((doc) => ({ uid: doc.id, ...doc.data() }));
}

export async function updateUserRole(uid, role) {
  var db = firebase.firestore();
  await db.collection("users").doc(uid).update({ role });
}
